import styled from "styled-components";

import { Metrics } from "../../vars";

export default styled.div`
  padding-top: ${Metrics.Heights.OVERLAY_TOOLBAR}px;
`;
